/** French translations. Keys missing here fall back to English (clearly marked in UI). */

import type { EnDictionary } from './en';

export const fr: Partial<Record<keyof EnDictionary, string>> = {
  'app.name': 'Traugily',
  'app.tagline': 'Des progrès réguliers, simplement',
  'nav.today': 'Aujourd’hui',
  'nav.plan': 'Plan',
  'nav.log': 'Journal',
  'nav.progress': 'Progrès',
  'nav.reports': 'Rapports',
  'nav.calendar': 'Calendrier',
  'nav.account': 'Compte',
  'nav.admin': 'Admin',

  'calendar.title': 'Calendrier',
  'calendar.prev_month': 'Mois précédent',
  'calendar.next_month': 'Mois suivant',
  'calendar.blocked': 'Indisponible',
  'calendar.no_workout': 'Aucune séance ce jour.',
  'calendar.begin_workout': 'Commencer la séance',
  'calendar.delete_workout': 'Supprimer la séance',
  'calendar.redo_workout': 'Supprimer et refaire la séance',
  'calendar.delete_hint': "Supprimer une séance terminée l'enlève de votre historique pour pouvoir la refaire.",
  'calendar.deleted': 'Séance supprimée.',
  'calendar.reset_for_redo': "Séance réinitialisée — elle est à nouveau planifiée et retirée de votre historique.",
  'calendar.status.planned': 'Planifiée',
  'calendar.status.completed': 'Terminée',
  'calendar.status.cancelled': 'Annulée',
  'calendar.status.rest': 'Repos',
  'action.begin_workout': 'Commencer la séance',
  'action.resume_workout': 'Reprendre la séance',
  'action.finish_workout': 'Terminer la séance',
  'action.save': 'Enregistrer',
  'action.cancel': 'Annuler',
  'action.confirm': 'Confirmer',
  'action.retry': 'Réessayer',
  'action.back': 'Retour',
  'action.next': 'Suivant',
  'action.change_password': 'Changer le mot de passe',
  'action.skip': 'Passer',
  'action.sign_in': 'Se connecter',
  'action.sign_up': 'Créer un compte',
  'action.sign_out': 'Se déconnecter',
  'action.discard_workout': 'Abandonner la séance',
  'action.keep_draft': 'Garder comme brouillon',
  'action.download': 'Télécharger',
  'action.generate_report': 'Générer le rapport',
  'action.accept': 'Accepter',
  'action.reject': 'Passer la suggestion',
  'action.close': 'Fermer',
  'state.loading': 'Chargement…',
  'state.empty_title': 'Rien ici pour l’instant',
  'state.error_title': 'Une erreur est survenue',
  'state.offline': 'Vous êtes hors ligne. Vos modifications sont enregistrées sur cet appareil.',
  'state.online': 'De retour en ligne. Synchronisation de vos modifications…',
  'state.saved_locally': 'Enregistré localement',
  'state.waiting_to_sync': 'En attente de synchronisation',
  'state.synced': 'Synchronisé',
  'state.sync_needs_attention': 'Synchronisation à vérifier',
  'state.conflict_title': 'La séance a changé sur un autre appareil',
  'state.conflict_body':
    'Rien n’a été écrasé. Choisissez la version à conserver — les deux enregistrements restent disponibles.',
  'state.conflict_keep_local': 'Garder les modifications de cet appareil',
  'state.conflict_keep_remote': 'Garder la version de l’autre appareil',
  'state.conflict_discard_confirm': 'Oui, supprimer mes saisies non synchronisées',
  'today.title': 'Aujourd’hui',
  'today.next_action': 'Votre prochaine étape',
  'today.no_session': 'Aucune séance prévue aujourd’hui',
  'today.rest_day': 'Jour de repos — la récupération fait partie du plan',
  'today.pending_proposals': '{count} suggestions d’adaptation vous attendent',
  'today.unread_notifications': '{count} notifications non lues',
  'today.start_onboarding': 'Configurez votre profil',
  'today.action.start_workout': 'Commencer la séance d’aujourd’hui',
  'today.action.resume_workout': 'Reprendre votre séance',
  'today.action.view_plan': 'Voir votre plan',
  'today.action.start_onboarding': 'Terminer la configuration',
  'today.action.no_workout_today': "Pas de séance aujourd'hui — reposez-vous.",
  'today.action.generate_plan': 'Générez votre plan',
  'today.plan_summary': 'Objectif de la semaine : {sessions} séances · {minutes} min chacune',
  'plan.title': 'Votre plan',
  'plan.phase': 'Phase actuelle',
  'plan.phase_remaining': '{weeks} semaines restantes',
  'plan.why': 'Pourquoi ce plan',
  'plan.assumptions': 'Hypothèses',
  'plan.rest_days': 'Jours de repos par semaine : {count}',
  'plan.weekly_rhythm': 'Rythme hebdomadaire',
  'plan.week.training': 'Entraînement',
  'plan.week.rest': 'Repos / récupération',
  'plan.accept_prompt': 'Vérifiez et acceptez votre plan pour commencer.',
  'plan.accept_confirm':
    'Je comprends qu’il ne s’agit pas d’un service médical et que je consulterai un professionnel en cas de douleur.',
  'plan.accepted': 'Plan activé',
  'plan.length_change': 'Changer la durée du plan',
  'plan.length_preview': 'Vérifiez la comparaison avant/après avant de confirmer.',
  'plan.length_before': 'Avant',
  'plan.length_after': 'Après',
  'plan.version': 'Version du plan {version}',
  'log.title': 'Journal d’entraînement',
  'log.history': 'Séances passées',
  'log.no_history': 'Aucune séance — votre première commence depuis Aujourd’hui.',
  'log.planned': 'Prévu',
  'log.actual': 'Réalisé',
  'log.rest_timer': 'Minuteur de repos',
  'log.report_pain': 'Signaler une gêne ou une douleur',
  'log.pain.discomfort': 'Gêne légère',
  'log.pain.pain': 'Douleur',
  'log.pain.urgent': 'Urgent — vertiges, douleur thoracique, évanouissement',
  'log.finish_summary': 'Résumé de la séance',
  'log.duration': 'Durée',
  'log.calories': 'Calories brûlées (estimation)',
  'log.calories_note': 'Estimation uniquement — pas une mesure médicale.',
  'log.set_empty': 'Saisissez répétitions, poids, RPE ou RIR avant d’enregistrer — les séries vides ne sont pas enregistrées.',
  'log.set_saved': 'Série enregistrée.',
  'log.set_queued_offline': 'Vous êtes hors ligne — la série est enregistrée sur cet appareil et sera synchronisée.',
  'log.finish_failed': 'Impossible de terminer la séance. Veuillez réessayer.',
  'safety.guidance.urgent':
    'Arrêtez l’entraînement immédiatement. En cas de douleur thoracique, évanouissement, vertiges, essoufflement soudain ou symptômes similaires, consultez un service d’urgence. Traugily ne peut pas évaluer vos symptômes.',
  'safety.guidance.pain':
    'Merci de nous l’avoir signalé. Consultez un professionnel de santé qualifié avant de reprendre ce mouvement. Nous n’augmenterons pas cet exercice tant que vous n’aurez pas choisi une étape sûre.',
  'safety.guidance.discomfort':
    'Une gêne légère arrive. Réduisez la charge ou l’amplitude, et arrêtez si cela empire ou persiste.',
  'safety.guidance.none': 'Merci pour votre signalement.',
  'progress.title': 'Progrès',
  'progress.weigh_in': 'Pesée hebdomadaire',
  'progress.weigh_in_hint':
    'Pour des mesures cohérentes, pesez-vous après les toilettes et avant le petit-déjeuner, à peu près à la même heure chaque semaine.',
  'progress.weight': 'Poids',
  'progress.trend': 'Tendance (moyenne mobile)',
  'progress.trend_note': 'Les tendances sont descriptives — pas un diagnostic.',
  'progress.consistency': 'Régularité',
  'progress.personal_records': 'Records personnels',
  'progress.goal_review': 'Revue des objectifs',
  'nutrition.title': 'Nutrition',
  'nutrition.targets': 'Objectifs quotidiens (estimations)',
  'nutrition.targets.estimate_notice':
    'Les objectifs sont des estimations basées sur votre profil, ajustées progressivement par phase. Ce ne sont pas des conseils médicaux.',
  'nutrition.suggestions': 'Idées de repas',
  'nutrition.log_meal': 'Noter un repas',
  'account.title': 'Compte',
  'account.language': 'Langue',
  'account.units': 'Unités',
  'account.sign_out': 'Se déconnecter',
  'account.export_data': 'Exporter mes données',
  'account.delete_account': 'Supprimer mon compte',
  'account.plan.free': 'Gratuit',
  'account.plan.premium': 'Premium',
  'account.subscribe': 'S’abonner — environ 5 €/mois',
  'account.manage_billing': 'Gérer la facturation',
  'account.change_password': 'Changer le mot de passe',
  'account.change_password_heading': 'Changer le mot de passe',
  'account.password_current': 'Ancien mot de passe',
  'account.password_new': 'Nouveau mot de passe',
  'account.password_confirm': 'Confirmer le nouveau mot de passe',
  'account.password_requirements': 'Au moins 10 caractères, avec une majuscule, une minuscule et un chiffre.',

  'account.password_changed': 'Mot de passe mis à jour.',

  'account.error.old_password_incorrect': 'L’ancien mot de passe est incorrect.',
  'auth.email': 'E-mail',
  'auth.password': 'Mot de passe',
  'auth.forgot': 'Mot de passe oublié ?',
  'auth.reset_sent': 'Si cet e-mail existe, un lien de réinitialisation est en route.',
  'auth.verify_notice':
    'Veuillez vérifier votre e-mail — le lien est dans votre boîte de réception.',
  'auth.google': 'Continuer avec Google',
  'auth.apple': 'Continuer avec Apple',
  'auth.have_account': 'Déjà un compte ?',
  'auth.no_account': 'Nouveau sur Traugily ?',
  'onboarding.title': 'Configurons votre plan',
  'onboarding.step': 'Étape {current} sur {total}',
  'onboarding.save_resume': 'Votre progression est enregistrée — reprenez quand vous voulez.',
  'onboarding.safety': 'La sécurité d’abord',
  'onboarding.safety_ack':
    'Je comprends qu’il ne s’agit pas d’un service médical et que je consulterai un professionnel en cas de douleur.',
  'admin.title': 'Admin',
  'admin.no_access': 'Vous n’avez pas accès à cette zone.',
  'admin.grant_premium': 'Accorder Premium',
  'admin.revoke_to_free': 'Passer en gratuit',
  'reports.title': 'Rapports',
  'reports.period': 'Période',
  'reports.detail': 'Niveau de détail',
  'reports.detail.summary': 'Résumé',
  'reports.detail.standard': 'Standard',
  'reports.detail.detailed': 'Détaillé',
  'reports.status.pending': 'En attente',
  'reports.status.processing': 'En cours de génération',
  'reports.status.ready': 'Prêt',
  'reports.status.failed': 'Échec',
  'reports.download': 'Télécharger le PDF',
  'reports.estimate_notice': 'Toutes les estimations du rapport sont étiquetées.',
  'reports.start_date': 'Date de début',
  'reports.end_date': 'Date de fin',
  'reports.language': 'Langue du rapport',
  'reports.history': 'Rapports précédents',
  'reports.empty': 'Aucun rapport pour l’instant',
  'reports.empty_hint': 'Choisissez une période ci-dessus et générez votre premier PDF.',
  'reports.polling': 'Génération de votre PDF — vérification du statut…',
  'reports.error_dates_required': 'Choisissez une date de début et de fin.',
  'reports.error_date_order': 'La date de fin doit être égale ou postérieure à la date de début.',
  'error.network': 'Impossible de joindre le serveur. Vos modifications locales sont en sécurité.',
  'error.validation': 'Veuillez vérifier les champs signalés.',
  'error.permission': 'Vous n’avez pas la permission pour cette action.',
  'error.generic': 'Une erreur est survenue. Veuillez réessayer.',
  'offline.banner': 'Mode hors ligne — ce que vous notez est d’abord enregistré sur cet appareil.',
} as const;
